/**
 * Per-device “I am this seat” for an active dining session (host + guests).
 * Lets each phone pick a physical seat id from session.seatIds so ordering / pay-by-seat match real people.
 */
const key = (sessionId) => `diningSeatClaim:${String(sessionId || "").trim()}`;

export function getMySeatClaim(sessionId) {
  const sid = String(sessionId || "").trim();
  if (!sid) return null;
  try {
    let v = sessionStorage.getItem(key(sid));
    if (!v) v = localStorage.getItem(key(sid));
    if (v != null && String(v).trim() !== "") {
      try {
        sessionStorage.setItem(key(sid), String(v).trim());
      } catch {
        /* ignore */
      }
      return String(v).trim();
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function setMySeatClaim(sessionId, seatId) {
  const sid = String(sessionId || "").trim();
  const sk = seatId != null ? String(seatId).trim() : "";
  if (!sid || !sk) return;
  try {
    sessionStorage.setItem(key(sid), sk);
    localStorage.setItem(key(sid), sk);
  } catch {
    /* ignore */
  }
}

export function clearMySeatClaim(sessionId) {
  const sid = String(sessionId || "").trim();
  if (!sid) return;
  try {
    sessionStorage.removeItem(key(sid));
    localStorage.removeItem(key(sid));
  } catch {
    /* ignore */
  }
}
